module.exports = __webpack_public_path__ + "img/pic3-2.71260066.png";